import { tokenAxios } from "@/utils/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateTaoBody } from "@/types/tao-routing";
import { useAppState } from "@/contexts/app-state";
import { Dispatch, SetStateAction } from "react";
import { buildApiUrl } from "@/utils/api";

interface NewTaoArgs {
    body: CreateTaoBody;
    practiceId: string;
    requestedUser: string;
}

interface MutationProps {
  onError?: Dispatch<SetStateAction<string>>
}

const postNewTao = async ({ body, practiceId, requestedUser }: NewTaoArgs) => {
    const response = await tokenAxios().post(buildApiUrl("createTaoRule"),
        body,
     {
        params: {
            practiceId,
            requestedUser
        }
      });
  return response;
};


  export const useCreateTao = ({ onError }: MutationProps) => {
    const { context, loggedInUser } = useAppState();
    const queryClient = useQueryClient();
    const practiceId = context?.athena?.practiceId ?? "8967";
    const { isPending, isError, isSuccess, mutateAsync, error } = useMutation({
      mutationFn: postNewTao,
      onSettled: async () => {
        return await queryClient.invalidateQueries({
          queryKey: ["tao-routing-rules"],
        });
      },
      onError: (err) => {
        if (onError) {
          onError(err.message);
        }
      }
    });

    const createTao = async (body: CreateTaoBody) => {
      try {
        return await mutateAsync({
          body: body,
          practiceId: practiceId,
          requestedUser: loggedInUser,
        });
      } catch (error) {
        if (onError && error) {
          onError(JSON.stringify(error));
        }
        throw error;
      }
    };

    return {
      isPending,
      isError,
      isSuccess,
      createTao,
      error
    };
  };
